module.exports = __webpack_public_path__ + "img/download-icon-dark.0fb6a2d3.svg";